// extracted by mini-css-extract-plugin
module.exports = {"button":"tooltip_button__ExekF","dark":"tooltip_dark__kyV9H","status":"tooltip_status__m04GY","review":"tooltip_review__kwwLZ"};